import React from "react";
import * as S from "./styles";

export const Banner: React.FC = () => {
  return (
    <>
      <S.Container></S.Container>
    </>
  );
};
